<template>
  <v-app>
    <AccessDialog />
    <Navigator
      v-if="isAuthenticated && $router.currentRoute.name !== 'Login'"
      :collapse="collapse"
      @onLogout="handleLogout"
    />

    <v-app-bar
      v-if="isAuthenticated && $router.currentRoute.name !== 'Login'"
      class="white"
      clipped-left
      app
    >
      <v-app-bar-nav-icon
        @click.stop="drawerController"
        color="text"
      ></v-app-bar-nav-icon>

      <v-toolbar-title class="text-h5">
        {{ $t($router.currentRoute.name) }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <TopProfile class="mr-2" />
    </v-app-bar>
    <v-main class="background">
      <router-view></router-view>
    </v-main>

    <!-- main app snackbar alert -->
    <v-snackbar
      v-model="alertVisibility"
      :color="alertError ? 'error' : 'success'"
      timeout="-1"
      bottom
      right
    >
      {{ alertText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" icon v-bind="attrs" @click="closeAlert">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- pwa update notification alert -->
    <v-snackbar v-model="updateExists" color="text" top right :timeout="-1">
      <v-btn small icon class="ml-1" @click="updateExists = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      {{ $t("pwa_update.new_version_available") }}
      <template v-slot:action="{ attrs }">
        <v-btn text color="secondaryYellow" v-bind="attrs" @click="refreshApp">
          {{ $t("pwa_update.update") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import {
  CLOSE_ALERT,
  SET_ALERT,
} from "@/core/services/store/modules/alert/alert.module";
import { LOGOUT } from "./core/services/store/modules/user/user.module";
import Navigator from "./components/structure/Navigator";
import AccessDialog from "./components/structure/AccessDialog";
import updatePWA from "./core/mixins/update.pwa";
import TopProfile from "./components/structure/TopProfile";
import { ROUTES } from "./routes/pwa";

export default {
  name: "App",

  data() {
    return {
      collapse: false,
      test: true,
    };
  },

  computed: {
    ...mapGetters([
      "isAuthenticated",
      "alertText",
      "alertVisibility",
      "alertError",
    ]),
  },

  watch: {
    alertVisibility: function (val) {
      if (val) {
        const timeout = setTimeout(() => {
          this.closeAlert();
          clearTimeout(timeout);
        }, 3000);
      }
    },
    isAuthenticated: function (val) {
      if (!val) {
        const currentPath = this.$route.path;
        if (currentPath !== ROUTES.login) {
          this.$router.replace({
            path: ROUTES.login,
            query: { "return-path": currentPath },
          });
          this.$store.commit(SET_ALERT, {
            text: this.$t("loginRequest"),
            isError: true,
          });
        }
      }
    },
  },

  methods: {
    drawerController() {
      this.collapse = !this.collapse;
    },
    closeAlert() {
      this.$store.dispatch(CLOSE_ALERT);
    },
    async handleLogout() {
      await this.$store.dispatch(LOGOUT);
    },
  },

  mixins: [updatePWA],

  components: {
    Navigator,
    TopProfile,
    AccessDialog,
  },
};
</script>

<style>
@import url(./assets/fonts/fonts.css);
@import url(./sass/style.scss);

/* Hide scrollbar for Chrome, Safari and Opera */
*::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
* {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/* set input suffix size */
.v-text-field__suffix {
  font-size: 14px !important;
}
.v-text-field__slot {
  font-size: 14px !important;
}
</style>
